import { useAuth0 } from "@auth0/auth0-react";
import { LinearProgress } from "@mui/material";
import { useSupabaseLoader } from "../../server/supabase/hooks";
import { getAllAccountLimits } from "../generic/hooks/use-account-limit";
import { AccountLimitProvider } from "./account-limit-context";

import type { FC, ReactNode } from "react";

export const AccountLimits: FC<{ children: ReactNode }> = ({ children }) => {
  const { loginWithRedirect } = useAuth0();
  const {
    loading,
    error,
    data: limits,
  } = useSupabaseLoader(
    async ({ supabase, account_id }) => await getAllAccountLimits(supabase, account_id),
    [],
  );

  if (loading) return <LinearProgress />;
  if (error) {
    void loginWithRedirect(
      window.location.pathname.includes("/logout")
        ? {}
        : { appState: { returnTo: `${window.location.pathname}${window.location.search}` } },
    );
    return <LinearProgress />;
  }

  return <AccountLimitProvider limits={limits}>{children}</AccountLimitProvider>;
};
